var Widget_Templates = [
    {
        name     : 'Web App Feedback',
        desc     : 'Collect issues and suggestions from users',
        settings : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 1,
            'workflow_type'           : 'bug,feature_request,general',
            'main_button_text'        : 'Feedback',
            'send_button_text'        : 'Send feedback',
            'use_modal'               : true,
            'capture_event'           : true,
            'capture_console_log'     : true,
            'capture_console_error'   : true,
            'capture_console_warn'    : true,
            'capture_console_info'    : true,
            'capture_console_debug'   : true,
            'capture_network'         : true
        }
    },
    {
        name     : 'Bug Tracking',
        desc     : 'Report bugs from your website or application',
        settings : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 6,
            'workflow_type'           : 'general',
            'main_button_text'        : 'Report a Bug',
            'send_button_text'        : 'Submit bug',
            'capture_event'           : true,
            'capture_console_log'     : true,
            'capture_console_error'   : true,
            'capture_console_warn'    : true,
            'capture_console_info'    : true,
            'capture_console_debug'   : true,
            'capture_network'         : true
        }
    },
    {
        name     : 'Website Design Feedback',
        desc     : 'Ideal for collecting feedback on your website designs',
        settings : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 5,
            'workflow_type'           : 'feature_request',
            'main_button_text'        : 'Feedback',
            'send_button_text'        : 'Send feedback',
            'capture_event'           : false,
            'capture_console_log'     : false,
            'capture_console_error'   : false,
            'capture_console_warn'    : false,
            'capture_console_info'    : false,
            'capture_console_debug'   : false,
            'capture_network'         : false
        }
    },
    {
        name     : 'Customer Satisfaction',
        desc     : 'Measure customer experience and satisfaction',
        settings : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 2,
            'workflow_type'           : 'general',
            'main_button_text'        : 'Rate us',
            'send_button_text'        : 'Submit',
            'capture_event'           : true,
            'capture_console_log'     : false,
            'capture_console_error'   : false,
            'capture_console_warn'    : false,
            'capture_console_info'    : false,
            'capture_console_debug'   : false,
            'capture_network'         : false
        }
    },
    {
        text     : 'Customer Engagement',
        desc     : 'Measure customer experience and satisfaction',
        settings : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 5,
            'workflow_type'           : 'bug',
            'capture_event'           : true,
            'capture_console_log'     : false,
            'capture_console_error'   : false,
            'capture_console_warn'    : false,
            'capture_console_info'    : false,
            'capture_console_debug'   : false,
            'capture_network'         : false
        }
    },
    {
        name       : 'Feature Request',
        desc       : 'Allow users to request new features and improvements',
        settings   : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 5,
            'workflow_type'           : 'bug,feature_request',
            'main_button_text'        : 'Request a feature',
            'send_button_text'        : 'Submit',
            'capture_event'           : true,
            'capture_console_log'     : false,
            'capture_console_error'   : false,
            'capture_console_warn'    : false,
            'capture_console_info'    : false,
            'capture_console_debug'   : false,
            'capture_network'         : false
        }
    },
    {
        name     : 'User Acceptance Testing',
        desc     : 'Allow testers to provide feedback and validate requirements',
        settings : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 5,
            'workflow_type'           : 'general',
            'main_button_text'        : 'Feedback',
            'send_button_text'        : 'Submit',
            'capture_event'           : true,
            'capture_console_log'     : true,
            'capture_console_error'   : true,
            'capture_console_warn'    : true,
            'capture_console_info'    : true,
            'capture_console_debug'   : true,
            'capture_network'         : true
        }
    },
    {
        name     : 'Image & PDF Feedback',
        desc     : 'Ideal for sharing designs with clients for their feedback',
        settings : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 5,
            'workflow_type'           : 'bug',
            'feedback_select'         : true,
            'main_button_text'        : 'Feedback',
            'send_button_text'        : 'Submit',
            'capture_event'           : false,
            'capture_console_log'     : false,
            'capture_console_error'   : false,
            'capture_console_warn'    : false,
            'capture_console_info'    : false,
            'capture_console_debug'   : false,
            'capture_network'         : false
        }
    },
    {
        name     : 'General Feedback',
        desc     : 'Collect general feedback on their website projects',
        settings : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 5,
            'workflow_type'           : 'feature_request,general',
            'main_button_text'        : 'Feedback',
            'send_button_text'        : 'Submit',
            'capture_event'           : false,
            'capture_console_log'     : false,
            'capture_console_error'   : false,
            'capture_console_warn'    : false,
            'capture_console_info'    : false,
            'capture_console_debug'   : false,
            'capture_network'         : false
        }
    },
    {
        name     : 'Other',
        settings : {
            'style'                   : 'text',
            'position'                : 'e',
            'icon'                    : 1,
            'workflow_type'           : 'feature_request',
            'main_button_text'        : 'Feedback',
            'send_button_text'        : 'Submit',
            'capture_event'           : true,
            'capture_console_log'     : false,
            'capture_console_error'   : false,
            'capture_console_warn'    : false,
            'capture_console_info'    : false,
            'capture_console_debug'   : false,
            'capture_network'         : false
        }
    }
];

export default Widget_Templates;